import React, {useEffect} from 'react';
import { EntityId } from "@reduxjs/toolkit";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import { selectUserEntities, selectUserIds } from "../../../../store/mods_factory/usersSlice";

import { Spin } from "antd";
import Pagination from '../../../../componets/Pagination';
import ListItem from "./_ListItem";
import { fetchPreviewAddons } from "../../../../actions/mods_factory/addonsActions";
import {useSearchParams} from "react-router-dom";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const ids             = useAppSelector(selectUserIds);
  const items           = useAppSelector(selectUserEntities);
  const previewAddons   = useAppSelector(state => state.modsFactory.users.previewAddons);
  const count           = useAppSelector(state => state.modsFactory.users.count);
  const error           = useAppSelector(state => state.modsFactory.users.error);
  const status          = useAppSelector(state => state.modsFactory.users.status);
  const term            = searchParams.get('term') || '';

  useEffect(() => {
    dispatch(fetchPreviewAddons({ id: previewAddons, limit: 210 }));
  }, [previewAddons, dispatch]);

  const renderList = (id: EntityId) => {
    const item = items[id];

    if (!item) {
      return;
    }

    return (
      <ListItem key={item.id} user={item} term={term} />
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      <div className='v-users-list'>
        {ids && ids.map(renderList)}
      </div>

      <Pagination total={count} size={limit} className='v-mt-10' />
    </>
  );
}

export default _List;
